<template>
  <div
    :style="{ height: `${headerHeight}px`}"
    class="wrapper"
  >
    <div
      :class="{'inner': true, 'inner--open': open}"
      @mouseleave="hideMenu"
    >
      <div
        ref="header"
        class="header"
        @mouseenter="showMenu"
      >
        <slot name="header" />
        <div class="header-arrow" >
          <ds-arrow :open="open" />
        </div>
      </div>
      <div class="content-wrapper">
        <div :class="{'content-inner': true, 'content-inner--open': open}">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as onClickOutside } from "vue-on-click-outside";
import DsArrow from "./ds-arrow";

export default {
  name: "DsDropdown",
  components: {
    DsArrow
  },
  mixins: [onClickOutside],
  data() {
    return {
      headerHeight: 0,
      open: false
    };
  },
  mounted() {
    this.recalculateDimensions();
  },
  methods: {
    showMenu() {
      this.open = true;
    },
    hideMenu() {
      this.open = false;
    },
    recalculateDimensions() {
      this.headerHeight = this.$refs.header.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

$speed: 0.15s;

.wrapper {
  position: relative;
}
.inner {
  position: relative;
  z-index: 10;
  display: inline-block;
  border: 2px solid;
  transition: $speed;
  border: 1px solid rgba(141, 153, 174, 0);
  box-shadow: 0 2px 10px 0 rgba(141, 153, 174, 0);
  border-radius: 5px;
  &--open {
    background: #fff;
    transition: $speed;
    border: 1px solid rgba(141, 153, 174, 0.5);
    box-shadow: 0 2px 10px 0 rgba(141, 153, 174, 0.4);
  }
}
.header {
  position: relative;
  display: flex;
  align-items: center;
  vertical-align: top;
  cursor: pointer;
  line-height: 16px;
  padding: 10px;
  z-index: 2;
  width: 100%;
  padding-left: 6px !important;
}
.header-arrow {
  align-self: flex-end;
  display: flex;
  align-items: center;
  align-self: center;
}
.content-wrapper {
  position: relative;
}
.content-inner {
  width: 100%;
  left: 0px;
  opacity: 0;
  pointer-events: none;
  transition: $speed;
  height: 0px;
  &--open {
    height: 100%;
    pointer-events: initial;
    transition: $speed;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-dropdown.vue